var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",function(){return [_c('span',{on:{"click":function($event){return _vm.download($event)}}},[_vm._v("download")])]},{"eventHandlers":_vm.eventHandlers,"loading":_vm.loading})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }